import React from 'react';
import styled from 'styled-components';
import { truncateText } from 'src/utilities/ApiHelper';
import { KatLink } from '@amzn/katal-react';
import Target = KatLink.Target;

interface LinkTextColumnFormatterProps {
  url: string;
  text: string;
  requiresTruncatedText?: boolean;
  textLength?: number;
  target?: Target;
}

const LinkTextColumnFormatterContainer = styled.div`
  kat-link {
    --font-size: 14px;
  }
`;
const LinkTextColumnFormatter: React.FC<LinkTextColumnFormatterProps> = ({
  url,
  text,
  requiresTruncatedText = false,
  textLength = 10,
  target = '_self',
}) => {
  const newTruncatedText = requiresTruncatedText
    ? truncateText(text, textLength)
    : text;
  return (
    <LinkTextColumnFormatterContainer>
      <KatLink href={url} target={target}>
        {newTruncatedText && newTruncatedText.endsWith('.') ? (
          <>{newTruncatedText}</>
        ) : (
          <>{text}</>
        )}
      </KatLink>
    </LinkTextColumnFormatterContainer>
  );
};

export default LinkTextColumnFormatter;
